function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2 10.2V7.12354C10.2 5.61154 9.87448 4.45654 8.11048 4.45654C7.25998 4.45654 6.69298 4.91854 6.46198 5.35954H6.44098V4.59304H4.77148V10.2H6.51448V7.41754C6.51448 6.68254 6.65098 5.97904 7.55399 5.97904C8.44649 5.97904 8.45699 6.80854 8.45699 7.45954V10.1895H10.2V10.2Z",
    fill: "#6B7280",
    style: {
      fill: "#6B7280",
      fill: "color(display-p3 0.4196 0.4471 0.5020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93652 4.59277H3.67952V10.1998H1.93652V4.59277Z",
    fill: "#6B7280",
    style: {
      fill: "#6B7280",
      fill: "color(display-p3 0.4196 0.4471 0.5020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80805 1.7998C2.25155 1.7998 1.80005 2.2513 1.80005 2.8078C1.80005 3.3643 2.25155 3.8263 2.80805 3.8263C3.36455 3.8263 3.81605 3.3643 3.81605 2.8078C3.81605 2.2513 3.36455 1.7998 2.80805 1.7998Z",
    fill: "#6B7280",
    style: {
      fill: "#6B7280",
      fill: "color(display-p3 0.4196 0.4471 0.5020)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.a655cfe6e8a7bee9af1fd1e1a16e6400.svg";
export { ForwardRef as ReactComponent };